define( [ 'utility' ], function run( utility ) {
	'use strict';

	var mShowhideFn = {

		init : function( elm ) {
			if ( !elm.classList.contains( 'js-m-showhide' ) ) {
				elm.classList.add( 'js-m-showhide' );

				elm.mShowhide = {}; // Setup mShowhide object

				// Get config data
				elm.mShowhide.config = utility.getData( elm );

				// Find all control element in the page
				elm.mShowhide.allControls = Array.from( document.querySelectorAll( '.m-showhide__heading' ) );
				// Get control elements which are not in a child showhide
				elm.mShowhide.controls = elm.mShowhide.allControls.filter( function filterFn( controlEl ) {
					return controlEl.closest( '.m-showhide' ) === elm;
				});

				// Hide content elements
				elm.mShowhide.controls.forEach( function loop( controlEl ) {
					var controlId = controlEl.getAttribute( 'id' ),
						autoId = 'term' + elm.mShowhide.allControls.indexOf( controlEl ),
						controlLink,
						contextHelpElm;

					// If the id already exists create a trully random one
					if ( document.querySelector( '#' + autoId ) ) {
						autoId = utility.makeId( 'term' );
					}

					utility.wrapInner( controlEl, 'button', 'm-showhide__control' );
					controlLink = controlEl.querySelector( '.m-showhide__control' );
					if ( controlId ) {
						autoId = controlId + '-term';
					}

					contextHelpElm = controlLink.querySelector( '.a-context-help' );
					if ( contextHelpElm ) {
						controlEl.append( contextHelpElm );
						controlEl.classList.add( 'has-contextual-help' );
						utility.wrap( contextHelpElm, utility.htmlStringToElement( '<div class="m-showhide__contextual-help-container"></div>' ) );
					}

					if ( controlEl.classList.contains( 'is-visible' ) ) {
						utility.setAttributes( controlLink, {
							type : 'button',
							'aria-controls' : autoId,
							'aria-expanded' : 'true',
						});

						controlEl.nextElementSibling.style.display = 'block';
						utility.setAttributes( controlEl.nextElementSibling, {
							id : autoId,
							'aria-hidden' : 'false',
						});
					} else {
						utility.setAttributes( controlLink, {
							type : 'button',
							'aria-controls' : autoId,
							'aria-expanded' : 'false',
						});

						controlEl.nextElementSibling.style.display = 'none';
						utility.setAttributes( controlEl.nextElementSibling, {
							id : autoId,
							'aria-hidden' : 'true',
						});
					}

					// Retain click tracking datasets
					if ( controlEl.classList.contains( 'dd-data-link' ) ) {
						// Add click tracking class to the button
						controlLink.classList.add( 'dd-data-link' );
						// Remove the class from the heading
						controlEl.classList.remove( 'dd-data-link' );
						// Get the dataset from the heading, convert back to kebab case, and add them to the button
						Object.keys( controlEl.dataset ).forEach( key => {
							// Fix hyphenated key names
							let keyString = '';
							// Split data key into an array around uppercase with match if required
							let tempArr = key.match( /[A-Za-z][a-z]+/g );
							// Concatenate and drop to lowercase - unless there is no split array in which case use key
							keyString = tempArr === null ? keyString = key : keyString += 'data-' + tempArr.join( '-' ).toLowerCase();
							// Add the data attribute to the button
							controlLink.setAttribute( keyString, controlEl.dataset[ key ] );
							// Remove the data attribute from the heading
							controlEl.removeAttribute( keyString );
						});
					}
				});

				elm.mShowhide.close = function close( targetId ) {
					var showHideHeading = elm.mShowhide.controls.filter( function filterFn( controlEl ) {
						return controlEl.closest( targetId ) !== null;
					});
					showHideHeading.forEach( function loop( controlEl ) {
						var controlBtn = controlEl.children[ 0 ];

						// If the section is open then close it
						if ( controlBtn.getAttribute( 'aria-expanded' ) === 'true' ) {
							mShowhideFn.toggleSelection( elm, controlBtn );
						}
					});
				};
				elm.mShowhide.closeAll = function closeAll() {
					// Loop though all the controls for the show/hide section
					elm.mShowhide.controls.forEach( function loop( controlEl ) {
						var controlBtn = controlEl.children[ 0 ];

						// If the section is open then close it
						if ( controlBtn.getAttribute( 'aria-expanded' ) === 'true' ) {
							mShowhideFn.toggleSelection( elm, controlBtn );
						}
					});
				};
				elm.mShowhide.open = function open( targetId, scrollTo ) {
					var showHideHeading = elm.mShowhide.controls.filter( function filterFn( controlEl ) {
						return controlEl.closest( targetId ) !== null;
					});
					showHideHeading.forEach( function loop( controlEl ) {
						var controlBtn = controlEl.children[ 0 ],
							parentsList,
							scrollParent,
							moveTo;

						if ( scrollTo ) {
							parentsList = utility.parents( elm, '.m-showhide__content' );
							parentsList.forEach( function parentLoop( parentEl ) {
								mShowhideFn.open( parentEl );
							});
							mShowhideFn.openSection( elm, targetId );

							scrollParent = utility.scrollParent( controlEl );
							moveTo = controlEl.offsetTop - scrollParent.offsetTop;

							utility.smoothScroll( 0, moveTo, FRAMEWORK.timings.current.t250ms, scrollParent );
						} else {
							mShowhideFn.toggleSelection( elm, controlBtn, true );
						}
					});
				};
				elm.mShowhide.openAll = function openAll() {
					if ( elm.mShowhide.config.accordion ) {
						// Do nothing as this is an accordion show/hide so only one at a time may be opened
					} else {
						elm.mShowhide.controls.forEach( function loop( controlEl ) {
							var controlBtn = controlEl.children[ 0 ];

							mShowhideFn.toggleSelection( elm, controlBtn, true );
						});
					}
				};

				// Add a link to each control pointing to an id set on the following element
				mShowhideFn.controlsClick( elm );
			}

			return elm.mShowhide;
		},

		openSection : function( elm, thisHref ) {
			var href = thisHref,
				targetElm,
				tempElm,
				sectionContentElm,
				sectionHeadingElm,
				openedSection = false;

			if ( thisHref.indexOf( '#' ) === 0 ) {
				href = '#' + CSS.escape( thisHref.substr( 1 ) );
			}

			targetElm = elm.querySelector( href );

			// If target element exists within showhide component then carry on processing
			if ( targetElm && elm.contains( targetElm ) ) {
				// Loop through until you find the outer most showhide content area
				tempElm = targetElm.closest( '.m-showhide__content, .m-showhide__heading' );
				while ( tempElm && elm.contains( tempElm ) ) {
					sectionContentElm = tempElm;
					tempElm = sectionContentElm.parentNode.closest( '.m-showhide__content, .m-showhide__heading' );
				}

				if ( sectionContentElm.classList.contains( 'm-showhide__content' ) ) {
					sectionHeadingElm = sectionContentElm.previousElementSibling; // Get the showhide heading
				} else {
					sectionHeadingElm = sectionContentElm; // It is the heading
				}

				mShowhideFn.toggleSelection( elm, sectionHeadingElm.querySelector( '.m-showhide__control' ), true, targetElm );

				openedSection = true;
			}

			return openedSection;
		},

		open : function( controlEl ) {
			controlEl.style.display = 'block';
			controlEl.setAttribute( 'aria-hidden', 'false' );
			controlEl.previousElementSibling.classList.add( 'is-visible' );
			controlEl.previousElementSibling.querySelectorAll( '.m-showhide__control' ).forEach( function loop( anchor ) {
				anchor.setAttribute( 'aria-expanded', 'true' );
			});
		},

		toggleSelection : function( elm, currentAnchor, open, targetElm ) {
			var parentId,
				parentEl,
				otherControls,
				toggleVariant = 'toggle';

			if ( !currentAnchor.classList.contains( 'is-animating' ) ) {
				currentAnchor.classList.add( 'is-animating' );
				parentEl = currentAnchor.parentNode;

				parentId = parentEl.getAttribute( 'id' );

				if ( parentId ) {
					utility.updateHistory( '#' + parentId );
				}

				if ( parentEl.classList.contains( 'is-visible' ) && !open ) {
					parentEl.classList.remove( 'is-visible' );
				} else {
					parentEl.classList.add( 'is-visible' );
				}

				if ( open ) {
					toggleVariant = 'down';
				}

				utility.slideToggle( parentEl.nextElementSibling, FRAMEWORK.timings.current.t500ms, {
					variant : toggleVariant,
					callback : function() {
						if ( open ) {
							currentAnchor.setAttribute( 'aria-expanded', 'true' );
							parentEl.nextElementSibling.setAttribute( 'aria-hidden', 'false' );
						} else {
							currentAnchor.setAttribute( 'aria-expanded', currentAnchor.getAttribute( 'aria-expanded' ) === 'true' ? 'false' : 'true' );
							parentEl.nextElementSibling.setAttribute( 'aria-hidden', currentAnchor.getAttribute( 'aria-expanded' ) === 'true' ? 'false' : 'true' );
						}
						currentAnchor.classList.remove( 'is-animating' );

						utility.trigger( window, 'refresh' );
					},
				});

				if ( elm.mShowhide.config.accordion || utility.getBreakpoint() === utility.smallTag ) {
					otherControls = elm.mShowhide.controls.filter( function filterFn( filterControlEl ) {
						return filterControlEl !== parentEl && filterControlEl.matches( '.is-visible' );
					});

					otherControls.forEach( function innerLoop( otherControlEl ) {
						otherControlEl.classList.remove( 'is-visible' );
						otherControlEl.children[ 0 ].classList.add( 'is-animating' );

						utility.slideToggle( otherControlEl.nextElementSibling, FRAMEWORK.timings.current.t350ms, {
							variant : 'up',
							callback : function() {
								var scrollToElm = elm,
									scrollParent,
									moveTo,
									thisOffset;

								if ( targetElm ) {
									scrollToElm = targetElm;
								}

								scrollParent = utility.scrollParent( scrollToElm );
								moveTo = scrollToElm.offsetTop - scrollParent.offsetTop;
								thisOffset = parentEl.offsetTop - scrollParent.offsetTop;

								if ( thisOffset < moveTo ) {
									utility.smoothScroll( 0, moveTo, FRAMEWORK.timings.current.t250ms, scrollParent );
								}

								otherControlEl.children[ 0 ].classList.remove( 'is-animating' );
								otherControlEl.children[ 0 ].setAttribute( 'aria-expanded', 'false' );
								otherControlEl.setAttribute( 'aria-hidden', 'true' );

								utility.trigger( window, 'refresh' );
							},
						});
					});
				}
			}
		},

		controlsClick : function( elm ) {
			var href = utility.getAnchor(),
				openedSection = false,
				thisControl;

			// Add a click event to the control to open the associated element
			elm.mShowhide.controls.forEach( function loop( controlEl ) {
				var currentAnchor = controlEl.children[ 0 ];

				currentAnchor.addEventListener( 'click', function listener( e ) {
					e.preventDefault();

					mShowhideFn.toggleSelection( elm, currentAnchor );
				});
			});


			document.addEventListener( 'click', function listener( e ) {
				var element = e.target,
					thisHref;

				// Get the href of the clicked element if there is one
				if ( element.hasAttribute( 'href' ) ) {
					thisHref = element.getAttribute( 'href' ).match( utility.urlAnchorRegExp );
				} else {
					element = element.closest( 'a[href], button[href]' );
					if ( element ) {
						thisHref = element.getAttribute( 'href' ).match( utility.urlAnchorRegExp );
					}
				}

				// Only try and process if the link is not blank
				if ( Array.isArray( thisHref ) && thisHref[ 0 ] !== '' && !element.classList.contains( 'm-showhide__control' ) ) {
					mShowhideFn.openSection( elm, thisHref[ 0 ] );
				}
			});

			// Open the associated element when the incoming link points to an id on a control
			if ( Array.isArray( href ) && href[ 0 ] !== '' ) {
				openedSection = mShowhideFn.openSection( elm, href[ 0 ] );
			}

			// No incoming link, so check for pre-opened flag instead
			if ( !openedSection ) {
				/* If a valid href is found check to see if it matches any of the showhide headings. */
				/* If no controls have been identified to open on load then check if there is one set to automatically open on load */
				thisControl = elm.mShowhide.controls.filter( function filterFn( controlEl ) {
					return controlEl.classList.contains( 'js-m-showhide-open' );
				});

				// Open any controls identified by the above
				if ( thisControl.length > 0 ) {
					thisControl.forEach( function loop( controlEl ) {
						mShowhideFn.open( controlEl.nextElementSibling );

						utility.parents( elm, '.m-showhide__content' ).forEach( function innerLoop( parentEl ) {
							mShowhideFn.open( parentEl );
						});
					});
				}
			}
		},
	};

	return {
		initInstance : function( elm ) {
			return mShowhideFn.init( elm );
		},
	};
});
